import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=cfb4bbc6&scoped=true"
import script from "./ActivityView.vue?vue&type=script&lang=js"
export * from "./ActivityView.vue?vue&type=script&lang=js"
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=cfb4bbc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb4bbc6",
  null
  
)

export default component.exports